import { TPublicBlogs } from '@/entities/Blogs/domain/Blogs.domain';
import { fetchBlogsByCategory } from '@/entities/Blogs/service';
import { useEffect, useState } from 'react';

const NEW_BLOGS_CHUNK_SIZE = 10;

export const useViewMoreBlogs = (
    destinationId: string,
    initBlogs: TPublicBlogs,
    skip?: boolean
) => {
    const [blogsList, setBlogsList] = useState(initBlogs.items);
    const [isBlogsLoading, setIsBlogsLoading] = useState(false);
    const [isBlogsEnded, setIsBlogsEnded] = useState(false);
    const [isBlogsTouched, setIsBlogsTouched] = useState(false);
    const [pager, setPager] = useState(initBlogs.pager);

    useEffect(() => {
        if (!skip) {
            setBlogsList(initBlogs.items);
            setPager(initBlogs.pager);
            setIsBlogsLoading(false);
            setIsBlogsEnded(!initBlogs.pager);
            setIsBlogsTouched(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [destinationId]);

    const viewMoreBlogs = async () => {
        if (isBlogsEnded) {
            return;
        }

        if (!isBlogsTouched) {
            setIsBlogsTouched(true);
        }

        setIsBlogsLoading(true);

        const isStateCode = !!destinationId && destinationId.length === 2 && !+destinationId;
        const isAuthorCode = !isStateCode && !!destinationId && !+destinationId;
        const isDestinationId = !isStateCode && !isAuthorCode;

        const newBlogs = await fetchBlogsByCategory({
            ...(isAuthorCode && { author: destinationId }),
            ...(isStateCode && { state: destinationId }),
            ...(isDestinationId && { category_id: destinationId }),
            limit: NEW_BLOGS_CHUNK_SIZE,
            ...(!!pager && { pager }),
        });

        if (!newBlogs.pager) {
            setIsBlogsEnded(true);
        }

        setIsBlogsLoading(false);
        setPager(newBlogs.pager);
        setBlogsList((prev) => prev.concat(newBlogs.items));
    };

    return {
        blogsList,
        isBlogsLoading,
        isBlogsTouched,
        isBlogsEnded,
        viewMoreBlogs,
    };
};
